import { Routes, Route } from "react-router-dom";
import {
  Application,
  Login,
  Register,
  Order,
  Admin,
  // Applicatoin pages
  OfflineOrdersOverview,
  OnlineOrdersOverview,
  Projects,
  CreateProject,
  ProjectDetails,
  Users,
  Profile,
  User,
  EditUser,
  OrderDetails,
  Batches,
  UnitsGroup,
  Offers,
  Parcels,
  MapPage,
  IntrestedList,
  TransactionsTracker,
  Transactions,
} from "containers/pageListAsync";
import {
  LOGIN,
  REGISTER,
  ORDER,
  // Application routes
  OFFERS,
  USERS,
  USER,
  PROFILE,
  EDIT_USER,
  PARCELS,
  MAP,
  OFFLINE_ORDERS,
  ONLINE_ORDERS,
  ONLINE_ORDER,
  BATCHES,
  UNIT_GROUPS,
  INTERSTED_LIST,
  PROJECTS,
  CREATE_PROJECT,
  PROJECT_DETAILS,
  TRANSACTIONS_TRACKER,
  SUBDIVISON_TRANSACTIONS,
  // Admin routes
  ADMIN_ORGANIZATIONS,
  ADMIN_ORGANIZATION,
  ADMIN_ADD_ORGANIZATION,
  ADMIN_USERS_INVITATIONS,
  ADMIN_USERS,
  ADMIN_MANAGE_ADMINS,
  ADMIN_MANAGE_TEST_USERS,
  ADMIN_SUHAIL_BADGES,
  ADMIN_SUHAIL_COMPLAINTS,
  ADMIN_SUHAIL_NOTIFICATIONS,
  ADMIN_SUHAIL_OFERS,
} from "./constants";

import {
  AddTestUsers,
  CreateOrganization,
  ManageAdmins,
  Organizations,
  OrganizationsDetails,
  UsersInvitations,
  Users as AdminUsers,
  SuhailBadges,
  ComplaintsList,
  SuhailNotifications,
  OffersList,
} from "containers/Admin/pages";

export function RouterConfig() {
  return (
    <Routes>
      <Route path={LOGIN} exact element={<Login />} />
      <Route path={ORDER} exact element={<Order />} />
      <Route path={REGISTER} exact element={<Register />} />
      <Route path="/*" element={<Application />} />
      <Route path="/admin/*" element={<Admin />} />
    </Routes>
  );
}

export function BookingRouterConfig() {
  return (
    <>
      <Route path={PARCELS} exact element={<Parcels />} />
      <Route path={MAP} exact element={<MapPage />} />
      <Route path={OFFLINE_ORDERS} exact element={<OfflineOrdersOverview />} />
      <Route path={ONLINE_ORDERS} exact element={<OnlineOrdersOverview />} />
      <Route path={ONLINE_ORDER} exact element={<OrderDetails />} />
      <Route path={BATCHES} exact element={<Batches />} />
      <Route path={UNIT_GROUPS} exact element={<UnitsGroup />} />
      <Route path={INTERSTED_LIST} exact element={<IntrestedList />} />
      <Route path={PROJECTS} exact element={<Projects />} />
      <Route path={CREATE_PROJECT} exact element={<CreateProject />} />
      <Route path={PROJECT_DETAILS} exact element={<ProjectDetails />} />
    </>
  );
}

export function BrokerageOfficeRouterConfig() {
  return (
    <>
      <Route path={OFFERS} exact element={<Offers />} />
      <Route path={USERS} exact element={<Users />} />
      <Route path={PROFILE} exact element={<Profile />} />
    </>
  );
}

export function TransactionsTrackerRouterConfig() {
  return (
    <>
      <Route
        path={TRANSACTIONS_TRACKER}
        exact
        element={<TransactionsTracker />}
      />
      <Route path={SUBDIVISON_TRANSACTIONS} exact element={<Transactions />} />
    </>
  );
}

export function SharedRouterConfig() {
  return (
    <>
      <Route path={USER} exact element={<User />} />
      <Route path={EDIT_USER} exact element={<EditUser />} />
    </>
  );
}

export function AdminRouterConfig() {
  return (
    <Routes>
      <Route path={ADMIN_ORGANIZATIONS} element={<Organizations />} exact />
      <Route
        path={ADMIN_ORGANIZATION}
        element={<OrganizationsDetails />}
        exact
      />
      <Route
        path={ADMIN_ADD_ORGANIZATION}
        element={<CreateOrganization />}
        exact
      />
      <Route path={ADMIN_USERS} element={<AdminUsers />} exact />
      <Route
        path={ADMIN_USERS_INVITATIONS}
        element={<UsersInvitations />}
        exact
      />
      <Route path={ADMIN_MANAGE_ADMINS} element={<ManageAdmins />} exact />
      <Route path={ADMIN_MANAGE_TEST_USERS} element={<AddTestUsers />} exact />
      <Route path={ADMIN_SUHAIL_BADGES} element={<SuhailBadges />} exact />
      <Route
        path={ADMIN_SUHAIL_COMPLAINTS}
        element={<ComplaintsList />}
        exact
      />
      <Route
        path={ADMIN_SUHAIL_NOTIFICATIONS}
        element={<SuhailNotifications />}
        exact
      />
      <Route path={ADMIN_SUHAIL_OFERS} element={<OffersList />} exact />
    </Routes>
  );
}
